import { css } from 'lit';

import token from '../../utils/get-token';
import color from '../../utils/get-color-token';
import { disabled, on, typography } from '../../styles';
import baseStyles from './base-button.styles';

function styles() {
	return [
		baseStyles(),
		css`
			.button.is-loading:not(.-icon, .-icon-secondary) *:not(.loader) {
				visibility: hidden;
			}

			.button.-primary {
				--m-button-background-color: ${color('color-primary-60')};
				--m-button-border-color: ${color('color-primary-60')};
				--m-button-color: ${color('color-text-inverted')};
			}

			${disabled('.button.-primary')} {
				--m-button-background-color: ${color('color-primary-20')};
				--m-button-border-color: ${color('color-primary-20')};
			}

			${on.focus('.button.-primary')} {
				--m-button-border-color: ${color('color-primary-60')};
				--m-button-outline-color: ${color('color-primary-60')};
			}

			${on.hover('.button.-primary')},
			${on.active('.button.-primary')} {
				--m-button-background-color: ${color('color-primary-100')};
				--m-button-border-color: ${color('color-primary-100')};
			}

			.button.-primary.is-loading {
				--m-button-background-color: ${color('color-primary-60')};
				--m-button-border-color: ${color('color-primary-60')};
				--m-button-color: ${color('color-text-inverted')};
			}

			.button.-secondary {
				--m-button-background-color: transparent;
				--m-button-border-color: ${color('color-primary-100')};
				--m-button-color: ${color('color-primary-100')};
			}

			${disabled('.button.-secondary')} {
				--m-button-border-color: ${color('color-text-disabled')};
				--m-button-color: ${color('color-text-disabled')};
			}

			${on.focus('.button.-secondary')} {
				--m-button-border-color: ${color('color-primary-100')};
				--m-button-color: ${color('color-primary-100')};

				--m-button-outline-color: ${color('color-primary-60')};
			}

			${on.hover('.button.-secondary')},
			${on.active('.button.-secondary')} {
				--m-button-background-color: ${color('color-background-tertiary')};
				--m-button-border-color: ${color('color-primary-60')};
				--m-button-color: ${color('color-primary-60')};
			}

			.button.-secondary.is-loading {
				--m-button-background-color: transparent;

				--m-button-border-color: ${color('color-primary-100')};
				--m-button-color: ${color('color-primary-100')};
			}

			.button.-tertiary {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
				--m-button-color: ${color('color-primary-100')};
			}

			${disabled('.button.-tertiary')} {
				--m-button-color: ${color('color-text-disabled')};
			}

			${on.focus('.button.-tertiary')} {
				--m-button-color: ${color('color-primary-100')};
				--m-button-outline-color: ${color('color-primary-60')};
			}

			${on.hover('.button.-tertiary')} {
				--m-button-background-color: ${color('color-background-tertiary')};
				--m-button-border-color: ${color('color-background-tertiary')};
				--m-button-color: ${color('color-primary-60')};
			}

			${on.active('.button.-tertiary')} {
				--m-button-background-color: ${color('color-neutral-20')};
				--m-button-border-color: ${color('color-neutral-20')};
				--m-button-color: ${color('color-primary-60')};
			}

			.button.-tertiary.is-loading {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
				--m-button-color: ${color('color-primary-100')};
			}

			.button.-warning {
				--m-button-background-color: ${color('color-warning-60')};
				--m-button-border-color: ${color('color-warning-60')};
				--m-button-color: ${color('color-text-primary')};
			}

			${disabled('.button.-warning')} {
				--m-button-background-color: ${color('color-warning-20')};
				--m-button-border-color: ${color('color-warning-20')};
				--m-button-color: ${color('color-text-inverted')};
			}

			${on.focus('.button.-warning')} {
				--m-button-background-color: ${color('color-warning-60')};
				--m-button-outline-color: ${color('color-warning-60')};
			}

			${on.hover('.button.-warning')},
			${on.active('.button.-warning')} {
				--m-button-background-color: ${color('color-warning-100')};
				--m-button-border-color: ${color('color-warning-100')};
				--m-button-color: ${color('color-text-inverted')};
			}

			.button.-warning.is-loading {
				--m-button-background-color: ${color('color-warning-60')};
				--m-button-border-color: ${color('color-warning-60')};
				--m-button-color: ${color('color-text-primary')};
			}

			.button.-danger {
				--m-button-background-color: ${color('color-danger-60')};
				--m-button-border-color: ${color('color-danger-60')};
				--m-button-color: ${color('color-text-inverted')};
			}

			${disabled('.button.-danger')} {
				--m-button-background-color: ${color('color-danger-20')};
				--m-button-border-color: ${color('color-danger-20')};
			}

			${on.focus('.button.-danger')} {
				--m-button-background-color: ${color('color-danger-60')};
				--m-button-outline-color: ${color('color-danger-60')};
			}

			${on.hover('.button.-danger')},
			${on.active('.button.-danger')} {
				--m-button-background-color: ${color('color-danger-100')};
				--m-button-border-color: ${color('color-danger-100')};
			}

			.button.-danger.is-loading {
				--m-button-background-color: ${color('color-danger-60')};
				--m-button-border-color: ${color('color-danger-60')};
				--m-button-color: ${color('color-text-inverted')};
			}

			.button.-icon,
			.button.-icon-secondary {
				--m-button-border-radius: ${token('border-radius-circle')};
				--m-button-color: ${color('color-neutral-90')};
				--m-button-padding-x: ${token('spacing-1')};
				--m-button-padding-y: ${token('spacing-1')};

				min-block-size: var(--m-button-base-size);
				max-block-size: var(--m-button-base-size);
				min-inline-size: var(--m-button-base-size);
				max-inline-size: var(--m-button-base-size);
			}

			.button.-icon {
				--m-button-background-color: ${color('color-background-tertiary')};
				--m-button-border-color: ${color('color-background-tertiary')};
			}

			.button.-icon-secondary {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			.button.-icon slot[name='leading']::slotted(*),
			.button.-icon slot[name='trailing']::slotted(*),
			.button.-icon-secondary slot[name='leading']::slotted(*),
			.button.-icon-secondary slot[name='trailing']::slotted(*) {
				display: none;
			}

			${disabled(['.button.-icon', '.button.-icon-secondary'])} {
				--m-button-color: ${color('color-neutral-40')};
			}

			${disabled('.button.-icon')} {
				--m-button-background-color: ${color('color-neutral-20')};
				--m-button-border-color: ${color('color-neutral-20')};
			}

			${disabled('.button.-icon-secondary')} {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			${on.focus(['.button.-icon', '.button.-icon-secondary'])} {
				--m-button-color: ${color('color-primary-60')};
				--m-button-outline-color: ${color('color-primary-60')};
			}

			${on.focus('.button.-icon')} {
				--m-button-background-color: ${color('color-neutral-20')};
			}

			${on.focus('.button.-icon-secondary')} {
				--m-button-background-color: transparent;
			}

			${on.hover(['.button.-icon', '.button.-icon-secondary'])},
			${on.active(['.button.-icon', '.button.-icon-secondary'])} {
				--m-button-color: ${color('color-primary-60')};
			}

			${on.hover('.button.-icon')},
			${on.active('.button.-icon')} {
				--m-button-background-color: ${color('color-background-highlight')};
				--m-button-border-color: ${color('color-background-highlight')};
			}

			${on.hover('.button.-icon-secondary')},
			${on.active('.button.-icon-secondary')} {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			.button.-small {
				--m-button-padding-y: ${token('spacing-2')};
				--m-button-base-size: ${token('global-height-small')};

				${typography('button-sm')};
			}

			.button.-large {
				--m-button-padding-y: ${token('spacing-4')};
				--m-button-base-size: ${token('global-height-large')};

				${typography('button-lg')};
			}

			/* TODO: to be removed when the loading dots component is ready */
			.loader {
				position: absolute;
				inset: 0;

				display: flex;
				align-items: center;
				justify-content: center;

				pointer-events: none;
			}
		`,
	];
}

export default styles;
